import React from 'react';
import { navigate } from 'gatsby';
import { useLocation } from '@reach/router';
import {
  EonUiSection,
  EonUiHeadline,
  EonUiTabNavigation,
  EonUiTabNavigationItem,
  EonUiWebsiteNavigation,
  EonUiWebsiteNavigationColumn,
  EonUiWebsiteNavigationLogo,
  EonUiWebsiteNavigationMain
} from '@eon-ui/eon-ui-components-react';
import Logo from '../assets/logo.svg';

const headerData = [{
  displayName: 'Flexibilitäts-Check',
  url: '/flex-check/flex-score'
}, {
  displayName: 'Zukunftsindex',
  url: '/zukunftsindex/co2-einsparung-jahr'
}, {
  displayName: 'E-Mobility',
  url: '/e-mobility/e-auto-besitzer'
}];

const Header = () => {
  const { pathname } = useLocation();

  return (
    <header className="eaHeader">
      <EonUiSection remove-top-spacing remove-bottom-spacing>
        <EonUiWebsiteNavigation sticky="false">
          <EonUiWebsiteNavigationMain slot="main">
            <EonUiWebsiteNavigationColumn
              visible-on-desktop
              visible-on-tablet
              visible-on-mobile
              content-alignment="left"
              content-alignment-tablet="left"
              content-alignment-mobile="left"
              grow-tablet
              grow-mobile
            >
              <EonUiWebsiteNavigationLogo
                image-src={Logo}
                description="E.ON Logo"
                href="https://www.eon.de/de/pk.html"
                target="_blank"
              />
            </EonUiWebsiteNavigationColumn>
          </EonUiWebsiteNavigationMain>
        </EonUiWebsiteNavigation>
        <div style={{ margin: '0 0 32px 0' }} />
        <EonUiHeadline size="h3" text="Energieatlas" />
        <div style={{ margin: '0 0 24px 0' }} />
        <EonUiTabNavigation>
          {headerData.map((item) => {
            const { displayName, url } = item;
            const pathCurrent = decodeURI(pathname).split('/').filter((path) => path)[0];
            const pathTarget = decodeURI(url).split('/').filter((path) => path)[0];

            return (
              <EonUiTabNavigationItem
                key={displayName}
                text={displayName}
                current={pathCurrent === pathTarget}
                onClick={() => navigate(decodeURI(url))}
              />
            );
          })}
        </EonUiTabNavigation>
      </EonUiSection>
    </header>
  )
};

export default React.memo(Header);